import { StoreBadges } from '../shared/StoreBadges';
import { PhoneMockup } from '../shared/PhoneMockup';
import styles from './DownloadCTABlock.module.css';

export function DownloadCTABlock() {
  return (
    <div className={styles.block}>
      <div className={styles.content}>
        <h3 className={`display ${styles.heading}`}>
          Your bucket list is ready. Don't lose it.
        </h3>
        <p className={styles.sub}>
          Save your matched fantasies in the app. Track them together. Check them off one by one. 😏
        </p>
        <ul className={styles.features}>
          <li>Save tonight's bucket list forever</li>
          <li>200+ intimate questions across 6 categories</li>
          <li>Dares from sweet & flirty to bold & uninhibited</li>
          <li>Roleplay stories you read aloud together</li>
          <li>Build your ultimate Sex Bucket List</li>
        </ul>
        <StoreBadges className={styles.badges} analyticsLocation="quiz_result" />
        <p className={styles.proof}>500k+ couples already playing</p>
      </div>
      <div className={styles.phone}>
        <PhoneMockup scale={0.6} />
      </div>
    </div>
  );
}
